import React from "react";
import { SocialIcons } from "react-social-icons";

import Modal from "../Modal/Modal";
import InnerModal from "../InnerModal/InnerModal";

import { translate, getLanguage } from "../Translation/Translation";

import "./OSCard.css";

class OSCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showImage: true,
      showMap: false,
      showInfo: false,
      showModal: false,
    };
    this.handleModalClick = this.handleModalClick.bind(this);
  }

  componentDidMount() {
    this.delayedShowMarker();
  }

  handleModalClick(event) {
    event.preventDefault();
    this.setState({ showModal: !this.state.showModal });
  }

  delayedShowMarker = () => {
    setTimeout(() => {
      this.setState({ isMarkerShown: true });
    }, 3000);
  };

  handleMarkerClick = () => {
    this.setState({ isMarkerShown: false });
    this.delayedShowMarker();
  };

  showImage = () => {
    this.setState({
      showImage: true,
      showMap: false,
    });
  };

  showMap = () => {
    this.setState({
      showImage: false,
      showMap: true,
    });
  };

  toggleInfo = () => {
    this.setState({
      showInfo: !this.state.showInfo,
    });
  };

  _onButtonClick() {
    this.setState({
      showComponent: true,
    });
  }

  _onButtonClick2() {
    this.setState({
      showComponent: false,
    });
  }

  render() {
    const {
      image,
      title,
      date,
      description,
      lat,
      lng,
      startDate,
      endDate,
      link,
      venueName,
    } = this.props;
    const { showModal } = this.state;
    const urls = [
      "https://www.facebook.com/liknoss/",
      "https://twitter.com/liknoss?lang=encolor=",
    ];
    return (
      <div className="card-container">
        <div className="card-image-container">
          <div
            className="card-image"
            style={{
              backgroundImage: `url(${image})`,
              backgroundPosition: "center",
              backgroundSize: "cover",
            }}
          />
        </div>
        <div className="card-info-container">
          <Modal open={showModal} clickOutSide={this.handleModalClick}>
            <InnerModal
              clickHandler={this.handleModalClick}
              date={date}
              title={title}
              lat={lat}
              lng={lng}
              description={description}
              image={image}
              startDate={startDate}
              endDate={endDate}
              venueName={venueName}
              link={link}
            />
          </Modal>
          <div className="card-title">{title}</div>
        </div>
        <div className="card-bottom-container">
          <div className="card-bottom-left">
            <SocialIcons urls={urls} />
          </div>
          <div className="card-bottom-right">
            <button
              className="card-action-button"
              onClick={this.handleModalClick}
            >
              {translate(getLanguage(), "Event Info")}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default OSCard;



// WEBPACK FOOTER //
// ./src/components/OSCard/OSCard.js